import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 bg-background-50">
      <div className="text-center">
        <h1 className="text-6xl md:text-8xl font-heading font-bold text-primary-500 mb-4">404</h1>
        <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-900 mb-3">
          页面未找到
        </h2>
        <p className="text-sm text-foreground-600 mb-8 max-w-md mx-auto">
          抱歉，您访问的页面不存在或已被移除。请检查链接是否正确，或返回首页继续浏览。
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-md font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
      </div>
    </div>
  );
}